import FindSimilarBoatsCard from './messages/FindSimilarBoatsCard';

const ActionCards = ({ booking, actions }) => {
  const action = actions?.find((ac) => ac.action_type === 'find_similar_boats');
  const url = action?.contexts?.find((con) => con.context_type === 'similar_boats_url')?.value;

  if (action && url && (booking.state === 'expired' || booking.state === 'declined')) {
    return <FindSimilarBoatsCard booking={booking} url={url} />;
  }
  return null;
};

export default ActionCards;
